import axios from 'axios';
import {history} from "../routes/Routing";
import Authentication from "../authentication/Authentication";

export default function Api() {

    /********************************************************/
    if (Api.prototype._singletonInstance) return Api.prototype._singletonInstance;
    Api.prototype._singletonInstance = this;
    /********************************************************/

    const endpoints = {
        pisaasInstances: '/pisaaslistservices',
        pisaasExceededLoadBalancer: '/pisaasloadbalancerexceeded',
        pisaasSignup: '/pisaassignup',
        pisaasStopInstance: '/stoppisaasservice',
        listPackages: '/pisaaslistpackages',
        pisaasUserSignup: '/pisaasusersignup',
        pisaasActiveInstances: '/pisaaslistactiveservices',
        pisaasCustomerInstances: '/pisaaslistcustomerservices',
        pisaasReactivateInstance: '/reactivatepisaasservice',
        trypiReactivateInstance: '/reactivatetrypiservice',
        trypiStopInstance: '/trypistopservice',
        pisaasListScheduledJob: '/pisaaslistscheduledjobsservices',
        pisaasListEmbeddedUrls: '/listembeddedurls',
        pisaasSetEmbeddedUrls: '/setemeddedurllist',
        pisaasSetJobDate: '/pisaassetscheduledjobdate',
        fetchServiceInfo: '/pisaasfetchserviceinfobyinstance',
        pisaasCheckForRunningDashboard: '/pisaascheckforrunningdashboard',
        pisaasSetScheduledJobDate: '/pisaassetscheduledjobdate',
        pisaasTagging: '/pisaastagging',
        pisaasListBackupVersions: '/pisaaslistbackupversions',
        pisaasListReleases: '/pisaaslistreleases',
        pisaasfetchjobprogress: '/pisaasfetchjobprogress',
        pisaasRestore: '/pisaasrestore',
        pisaasCreateS3PresignedPost: '/pisaascreates3presignedpost',
        pisaasDuplicate: '/pisaasduplicateinstance',
        pisaasTerminate: '/terminateservice',
        pisaasSideload: '/pisaaslistresourcesbyinstance',
        pisaasRestart: '/pisaasrestartdashboard',
        pisaasDownloadResource: '/pisaaspreparedownloadresourceurl',
        pisaasfetchenvinfobyinstance:'/pisaasfetchenvinfobyinstance'
    };

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_SERVER_URL,
        headers: {
            common: {
                'Content-Type': 'application/json'
            }
        }
    });

    axiosInstance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.response && error.response.status === 401) {
            history.push('/');
            return;
        }
        return Promise.reject(error);
    });

    this.fetchPisaasInstances = function (successCallback, errorCallback) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.get(endpoints.pisaasInstances, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasExceededLoadBalancer = function (successCallback, errorCallback) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.get(endpoints.pisaasExceededLoadBalancer, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasSignupUser = function (successCallback, errorCallback, email, serviceName, packageId, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasSignup, {'email': email, 'domain': serviceName, 'package_id': packageId, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successful sign up")
                    successCallback(response.data);
                })
                .catch((err) => {
                    console.log(err)
                    errorCallback(err)
                })
        });
    }


    this.stopPisaasInstance = function (errorCallback, serviceName, instance_id, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasStopInstance, {'domain': serviceName, "pisaas_instance_id": instance_id, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully stopped instance")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.stopTrypiInstance = function (errorCallback, serviceName, instance_id) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.trypiStopInstance, {'domain': serviceName, "pisaas_instance_id": instance_id}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully stopped instance")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.reactivatePisaasInstance = function (errorCallback, serviceName, instance_id, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasReactivateInstance, {'domain': serviceName, "pisaas_instance_id": instance_id, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully reactivated instance")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.reactivateTrypiInstance = function (errorCallback, serviceName, instance_id) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.trypiReactivateInstance, {'domain': serviceName, "pisaas_instance_id": instance_id}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully reactivated instance")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.fetchPackages = function (successCallback, errorCallback) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.get(endpoints.listPackages, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasUserSignup = function (successCallback, errorCallback, packageId) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasUserSignup, {'package_id': packageId}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successful sign up")
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasFetchCustomerInstances = function (successCallback, errorCallback) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.get(endpoints.pisaasCustomerInstances, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    };

    this.pisaasFetchScheduledJobs = function (successCallback, errorCallback) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.get(endpoints.pisaasListScheduledJob, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    };

    this.fetchWhitelistedUrls = function (successCallback, errorCallback, domain) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasListEmbeddedUrls, {'domain': domain}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.setWhitelistedUrls = function (successCallback, errorCallback, domain, embedded_url_list, pisaas_instance_id, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasSetEmbeddedUrls, {'domain': domain, 'embedded_url_list': embedded_url_list,  'pisaas_instance_id': pisaas_instance_id, "region": region},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback();
                })
                .catch(errorCallback)
        });
    }

    this.customScheduledJobEndDate = function (successCallback, errorCallback, domain, embedded_url_list, pisaas_instance_id) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasSetJobDate, {'domain': domain, 'embedded_url_list': embedded_url_list,  'pisaas_instance_id': pisaas_instance_id},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback();
                })
                .catch(errorCallback)
        });
    }

    this.fetchServiceInfoByInstance = function (successCallback, errorCallback, domain, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.fetchServiceInfo, {'service_name': domain, 'region': region},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.checkForRunningDashboard = function (successCallback, errorCallback, domain, instanceType, trypiUrl) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasCheckForRunningDashboard, {'service_name': domain, "instance_type": instanceType, "trypi_url": trypiUrl},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response);
                })
                .catch(errorCallback)
        });
    }

    this.customScheduledJobEndDate = function (successCallback, errorCallback, jobQueueId, scheduledDate) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasSetScheduledJobDate, {'job_queue_id': jobQueueId, 'scheduled_date_difference': scheduledDate},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasListTags = function (successCallback, errorCallback, pisaasInstanceId) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasTagging, {'pisaas_instance_id': pisaasInstanceId, "type": "list"},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data.response);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasUpdateTags = function (successCallback, errorCallback, pisaasInstanceId, instanceTagsToSave, instanceTagsToDelete) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasTagging, {'pisaas_instance_id': pisaasInstanceId, 'instance_tags': instanceTagsToSave, "type": "upsert"},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    axiosInstance.post(endpoints.pisaasTagging, {'pisaas_instance_id': pisaasInstanceId, 'instance_tags': instanceTagsToDelete, "type": "delete"},  {headers: {common: {"Authorization": token}}})
                        .then(function (response) {
                            successCallback(response.data);
                        })
                        .catch(errorCallback)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasListBackupVersions = function (successCallback, errorCallback, domain, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasListBackupVersions, {'domain': domain, "region": region},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasListReleases = function (successCallback, errorCallback, domain, region) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasListReleases, {'domain': domain, "region": region},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasFetchJobProgress = function (successCallback, errorCallback, instanceId) {
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasfetchjobprogress, {'pisaas_instance_id': instanceId},  {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data);
                })
                .catch(errorCallback)
        });
    }

    this.pisaasRestore = function (successCallback, errorCallback, serviceName, versionToRestore, instanceId, packageId, region) {
        const authentication = new Authentication();
        console.log(region)


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasRestore, {'service_name': serviceName, "version_id": versionToRestore, "pisaas_instance_id": instanceId, "package_id": packageId, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully restored sql")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.pisaasCreateS3PresignedPost = function (successCallback, errorCallback, serviceName, fileName, bucketName, region, filePath=false) {
        console.log(region)
        const authentication = new Authentication();

        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasCreateS3PresignedPost, {'service_name': serviceName, "file_name": fileName, "bucket_name": bucketName, "file_path": filePath, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data, fileName)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasTerminate = function (errorCallback, serviceName, instanceId, region) {
        const authentication = new Authentication();


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasTerminate, {'domain': serviceName, "pisaas_instance_id": instanceId, 'region': region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    console.log("Successfully terminated instance")
                    return response.data
                })
                .catch(errorCallback)
        });
    }

    this.pisaasDuplicate = function (successCallback, errorCallback, originalServiceName, newServiceName, packageId, email, originalEmail, region) {
        const authentication = new Authentication();


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasDuplicate, {'original_service_name': originalServiceName, "new_service_name": newServiceName, "package_id": packageId, "email": email, "original_email": originalEmail, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasSideload = function (successCallback, errorCallback, domain, region) {
        const authentication = new Authentication();


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasSideload, {"service_name": domain, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasRestartDashboard = function (successCallback, errorCallback, domain, region) {
        const authentication = new Authentication();


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasRestart, {"service_name": domain, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasDownloadResource = function (successCallback, errorCallback, domain, resourceType, region, filePath=undefined) {
        const authentication = new Authentication();


        authentication.fetchToken(function (token) {
            axiosInstance.post(endpoints.pisaasDownloadResource, {"service_name": domain, "resource_type": resourceType, "file_path": filePath, "region": region}, {headers: {common: {"Authorization": token}}})
                .then(function (response) {
                    successCallback(response.data, resourceType, filePath)
                })
                .catch(errorCallback)
        });
    }

    this.pisaasFetchEnvInfoByInstance = (successCallback, errorCallback, service_name, region) => {
        const authentication = new Authentication();

        authentication.fetchToken((token) =>{
            axiosInstance.post(endpoints.pisaasfetchenvinfobyinstance, {'service_name': service_name, 'region': region}, {headers: {common: {'Authorization': token}}})
                .then((response) => {successCallback(response.data)})
                .catch(errorCallback)
        } );
    }
}
